import React, { useEffect, useState } from 'react';

import { client } from 'cccisd-apollo';
import { Certificate } from 'cccisd-laravel-assignment';
import PlatformMediator from 'cccisd-laravel-assignment/dist/components/navigations/courseWrapper/Mediator/CourseWrapperMediator';
import Loader from 'cccisd-loader';
import Modal from 'cccisd-modal';
import { Route, withRouter, useParams } from 'cccisd-react-router';
import certQuery from './certificateQuery.graphql';

const MediatorRoot = ownProps => {
    const { mediatorProps, actingPawnId, actingPawnHash } = ownProps;
    const [certData, setCertData] = useState(null);
    const { productHandle } = useParams();

    useEffect(() => {
        async function getCertData() {
            const res = await client.query({
                query: certQuery,
                fetchPolicy: 'network-only',
                variables: {
                    deploymentHandle: `${productHandle}_training`,
                    actingPawnId,
                    actingPawnHash,
                },
            });

            setCertData(res?.data?.roles?.anyRole || {});
        }

        getCertData();
    }, []);

    if (!certData) {
        return <Loader loading />;
    }

    let showBanner = false;
    let editedProps = mediatorProps;
    /* If someone has Manage field toggled ON that they already did this training,
        then just show them the Certificate banner straight away.
    */
    try {
        const { allAelProgress, allSsGrinProgress, thisCourse, currentLicenseList, fields } = certData;

        const trained = JSON.parse(fields?.trained || {});
        const isTrainedViaManageField = trained && trained[productHandle];
        showBanner = !thisCourse.completed && isTrainedViaManageField;

        /* AEL K, 1, 2, 3, 4, 5 all have the same content.
            If user completed one, then show that certificate for all
        */
        if (productHandle.startsWith('ael')) {
            const isOtherAelComplete = allAelProgress.some(
                ap => ap.completed && ap.deployment.deploymentHandle !== `${productHandle}_training`
            );
            showBanner = showBanner || (!thisCourse.completed && isOtherAelComplete);
        }

        /* S.S.Grin K-2 and 3-5 have exactly the same content, so we don't make them repeat the Training...
            - If someone owns only K-2 with no nexus_fields.trained flags toggled, then their certificate will say K-2
            - If someone owns only 3-5 with no nexus_fields.trained flags toggled, then their certificate will say 3-5
            - If someone owns both K-2 and 3-5, then their certificate will say K-5
            - If someone owns only K-2 or only 3-5, but has nexus_fields.trained.ssgrin_k2 OR nexus_fields.trained.ssgrin_35,
                then they were trained externally, and their certificate will say K-5
        */
        if (productHandle === 'ssgrin_k2' || productHandle === 'ssgrin_35') {
            const otherProductHandle = productHandle === 'ssgrin_k2' ? 'ssgrin_35' : 'ssgrin_k2';
            const isOtherComplete = allSsGrinProgress.some(
                ap => ap.deployment.deploymentHandle === `${otherProductHandle}_training` && ap.completed
            );
            showBanner = showBanner || (!thisCourse.completed && (isTrainedViaManageField || isOtherComplete));

            editedProps = { ...mediatorProps };
            const ownsOtherCourse = currentLicenseList.some(
                ownedLicense => ownedLicense.product.handle === otherProductHandle
            );

            if (!ownsOtherCourse && !isTrainedViaManageField) {
                editedProps.certificate.certificates[0].courseName =
                    productHandle === 'ssgrin_k2' ? 'S.S.GRIN K-2' : 'S.S.GRIN 3-5';
            }
        }
    } catch (e) {
        // meh, just don't show the banner
    }

    const isStarted = ownProps.flowList.some(f => f.isStarted);
    return (
        <Route
            path={`${ownProps.match.path}/:courseWrapperTab?`}
            render={props => (
                <>
                    {showBanner && (
                        <div className="alert alert-success mb-5">
                            <h3 className="alert-heading mb-3">Training for this course has already been completed!</h3>
                            <Modal
                                trigger={
                                    <button type="button" className="btn btn-primary">
                                        View Completion Certificate
                                    </button>
                                }
                                title="Certificate"
                            >
                                <Certificate
                                    {...ownProps}
                                    basePath={ownProps.match.url}
                                    settings={mediatorProps.certificate}
                                    // if no progress yet, prevent the default Certificate from trying to look it up
                                    {...(!isStarted ? { actingPawnId: null } : {})}
                                />
                            </Modal>
                        </div>
                    )}
                    <PlatformMediator
                        {...ownProps}
                        {...props}
                        basePath={ownProps.match.url}
                        mediatorProps={editedProps}
                    />
                </>
            )}
        />
    );
};

export default withRouter(MediatorRoot);
